import { render, staticRenderFns } from "./VideoDetails.vue?vue&type=template&id=6b7c59ae&"
import script from "./VideoDetails.vue?vue&type=script&lang=ts&"
export * from "./VideoDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7c59ae')) {
      api.createRecord('6b7c59ae', component.options)
    } else {
      api.reload('6b7c59ae', component.options)
    }
    module.hot.accept("./VideoDetails.vue?vue&type=template&id=6b7c59ae&", function () {
      api.rerender('6b7c59ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/VideoDetails.vue"
export default component.exports